module.exports = __webpack_public_path__ + "img/andong_gallery0.6bd42b23.jpg";